export enum LinkMode {
  Default = 'default',
  HasPlainLook = 'has-plain-look',
  HasDarkBackground = 'has-dark-background',
  HasBorder = 'has-border',
  HasUnderline = 'has-underline',
  WithArrowRight = 'with-arrow-right',
}
